import store from "@/store";

function getUrl() {
  return store.state.user.user.sysType == 1 ? "/outsource" : "/customer";
}

function getParams(query, page) {
  let params = {
    pageNum: page.current,
    pageSize: page.size,
  };
  for (let k of Object.keys(query)) {
    if (query[k]) {
      params[k] = query[k];
    }
  }
  return params;
}

export default function (axios) {
  return {
    // 供应商列表,
    providerList(query, page, nose) {
      let params = getParams(query, page);
      let url = `${getUrl()}/getSelectList`;
      // nose参数控制接口读取的是否是需要token的，nose空读取需要token的接口；nose有值读取不需要token的接口
      url = url + (nose ? "Nose" : "");
      return axios.post(url, {}, { params });
    },
  }
}